<template>
  <section-page
    title="Appointment Defaults"
    description="Choose how you would like to be notified for an appointment reminder."
    is-short
  >
    <grid-row>
      <grid-column>
        <template v-if="hasTextNotificationsIntegration">
          <form-field-switch
            label="Send Text Reminder"
            v-model="textReminder"
          />

          <form-field-time-in-minutes
            label="Time Before Sending"
            v-model="form.time_before_text_appointment_reminder"
            :validation-errors="validationErrors.time_before_text_appointment_reminder"
            :disabled="!textReminder"
          />
        </template>

        <template v-else>
          <p class="upgrade_message mt-100 mb-50"><strong>Upgrade Required</strong></p>
          <p class="upgrade_message">Please <a @click="openBillingPortal">upgrade</a> your subscription to receive text notifications</p>
        </template>
      </grid-column>

      <grid-column>
        <template v-if="hasEmailNotificationsIntegration">
          <form-field-switch
            label="Send Email Reminder"
            v-model="emailReminder"
          />

          <form-field-time-in-minutes
            label="Time Before Sending"
            v-model="form.time_before_email_appointment_reminder"
            :validation-errors="validationErrors.time_before_email_appointment_reminder"
            :disabled="!emailReminder"
          />
        </template>

        <template v-else>
          <p class="upgrade_message mt-100 mb-50"><strong>Upgrade Required</strong></p>
          <p class="upgrade_message">Please <a @click="openBillingPortal">upgrade</a> your subscription to receive email notifications</p>
        </template>
      </grid-column>
    </grid-row>

    <div class="flex flex-end">
      <button-default
        :loading="isSaving"
        @click="update"
      >
        Update
      </button-default>
    </div>
  </section-page>
</template>

<script>
import {FormMixin} from "../../../forms/forms.mixin";

export default {
  name: "ProfileAppointmentDefault",
  mixins: [FormMixin],
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isSaving: false,
      textReminder: false,
      emailReminder: false,
      form: {
        time_before_text_appointment_reminder: null,
        time_before_email_appointment_reminder: null,
      },
      validationErrors: {}
    }
  },
  mounted() {
    if (this.user.time_before_text_appointment_reminder !== null) {
      this.textReminder = true
      this.form.time_before_text_appointment_reminder = this.user.time_before_text_appointment_reminder
    }

    if (this.user.time_before_email_appointment_reminder !== null) {
      this.emailReminder = true
      this.form.time_before_email_appointment_reminder = this.user.time_before_email_appointment_reminder
    }
  },
  computed: {
    hasEmailNotificationsIntegration() {
      return this.$store.state.accounts.features.EmailNotifications;
    },
    hasTextNotificationsIntegration() {
      return this.$store.state.accounts.features.TextNotifications;
    },
  },
  methods: {
    update() {
      let payload = {
        time_before_text_appointment_reminder: (this.textReminder) ? this.form.time_before_text_appointment_reminder : null,
        time_before_email_appointment_reminder: (this.emailReminder) ? this.form.time_before_email_appointment_reminder : null
      };

      this.isSaving = true;
      return this.$api.users.updateAppointmentDefaults(this.user.id, payload)
        .then((res) => {
          this.$buefy.toast.open({
            message: "User Appointment Defaults were saved",
            type: 'is-success'
          });

          return res;
        })
        .finally(() => this.isSaving = false);
    }
  }
}
</script>

<style scoped>
.upgrade_message {
  font-style: italic;
  line-height: 1.2;
}
</style>
